export const timeSpanToSeconds = ({
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
}) => days * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60 + seconds;
